import React, { createContext, useState, useContext } from "react";

interface ClientsDashboardContextType {
  mediatorCode: string;
  setMediatorCode: (code: string) => void;
}

const ClientsDashboardContext = createContext<ClientsDashboardContextType | undefined>(undefined);

export const ClientsDashboardProvider: React.FC = ({ children }) => {
  const [mediatorCode, setMediatorCode] = useState<string>("");

  return (
    <ClientsDashboardContext.Provider value={{ mediatorCode, setMediatorCode }}>
      {children}
    </ClientsDashboardContext.Provider>
  );
};

export const useClientsDashboardContext = () => {
  const context = useContext(ClientsDashboardContext);
  if (!context) {
    throw new Error("Error, inténtelo más tarde");
  }
  return context;
};
